import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal-dialog-contractorproxy',
  templateUrl: './dialog-contractorproxy.component.html',
  styles: []
})
export class DialogContractorProxyComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogContractorProxyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  public onClickConfirm(): void {
    this.dialogRef.close(true);
  }

  public onClickCancel(): void {
    this.dialogRef.close(false);
  }

}
